import { Action } from '@ngrx/store';

export enum SigningActionTypes {
    SIGNING_SUCCESS = '[Signing] Successful document signing'
}

export class ActionSigningSuccess implements Action {
    readonly type = SigningActionTypes.SIGNING_SUCCESS;
    constructor() { }
}

export type SingingActions = ActionSigningSuccess;
